import { Flex, StyleProps } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/pro-duotone-svg-icons/faImage';

export function PlaceholderImage(props: StyleProps) {
   return (
      <Flex
         backgroundColor="white"
         borderWidth={1}
         borderRadius="4px"
         justifyContent="center"
         alignItems="center"
         {...props}
      >
         <Flex
            backgroundColor="gray.200"
            borderRadius="100px"
            alignSelf="center"
            justifyContent="center"
            alignItems="center"
            width="36px"
            height="36px"
         >
            <FontAwesomeIcon fontSize="16px" icon={faImage} />
         </Flex>
      </Flex>
   );
}
